import { render, staticRenderFns } from "./resourceGroup.vue?vue&type=template&id=5778d45d&"
import script from "./resourceGroup.vue?vue&type=script&lang=js&"
export * from "./resourceGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports